import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { ChatbotFunService } from './chatbot-fun.service';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  private currentPageSource = new BehaviorSubject<any>('home');
  homeHistory$ = this.currentPageSource.asObservable();
  private lastMessageHistoryLengthSubject = new BehaviorSubject<number>(1);
   private apiUrl = `${environment.ceServerURL}/reports/lastmessagehistory`;
  private botConfigs = environment.chatbots;

  sessionId = localStorage.getItem("sessionId");

  constructor(private http: HttpClient, public chatbotFunService: ChatbotFunService) { }

  // Function to get start date (30 days ago) and end date (current date)
  getLast30DaysTimestamps() {
    const currentDate = new Date();  // Get the current date (end date)
    
    // Calculate the start date (30 days before the current date)
    const startDate = new Date(currentDate);
    startDate.setDate(currentDate.getDate() - 30);  // Subtract 30 days from the current date

    // Get the timestamps (milliseconds since epoch)
    const start = startDate.getTime(); // Start timestamp (30 days ago)
    const end = currentDate.getTime();  // End timestamp (current date)

    return { start, end };
  }

  setCurrentPage(value: any) {
    this.currentPageSource.next(value);
  }

  getCurrentPage(): boolean {
    return this.currentPageSource.getValue(); // Get the latest value
  }

  // Function to get the message history
  getLastMessageHistory(): Observable<any> {
    const { start, end } = this.getLast30DaysTimestamps();  // Get timestamps for 30 days before and current date
    
    // Set query parameters
    let params = new HttpParams()
      .set('botId', this.chatbotFunService.isArabic() 
      ? this.getBotIdForLanguage('ar') 
      : this.getBotIdForLanguage('en'))
      .set('end', end.toString())
      .set('start', start.toString())
      .set('type', 'messageHistory')
      .set('sessionId', this.sessionId);

    const httpOptions = {
      headers: new HttpHeaders({}),
      params: params
    };

    return this.http.get<any>(this.apiUrl, httpOptions);
  }
  setLastMessageHistoryLength(length: number) {
    this.lastMessageHistoryLengthSubject.next(length);
  }
  
  getLastMessageHistoryLength() {
    return this.lastMessageHistoryLengthSubject.asObservable(); 
  }

  getBotIdForLanguage(language: string): string {
    const botConfig = this.botConfigs.find(config => config.language === language);
    return botConfig ? botConfig.Id : ''; 
  }
}
